"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DATA_REVALIDATE_SECONDS = void 0;
exports.fetchFile = fetchFile;
const errors_1 = require("../errors/index.js");
exports.DATA_REVALIDATE_SECONDS = 60;
async function fetchFile({ url }) {
    const response = await fetch(url, { next: { revalidate: exports.DATA_REVALIDATE_SECONDS } });
    if (response.status === 404) {
        throw new errors_1.NotFoundError(`File \`${url}\` not found`);
    }
    if (response.status === 500) {
        throw new errors_1.InternalServerError(`Server error while fetching \`${url}\` file`);
    }
    if (!response.ok) {
        throw new Error(`HTTP ${response.status}: ${response.statusText} for \`${url}\` file`);
    }
    return await response.json();
}
